import React, { useEffect, useState } from 'react';
import { ElevatedButton } from '@producer/ui-kit';
import { PlusIcon } from '@radix-ui/react-icons'

import { SettingScreenLayout } from '../../../features/settings/components/setting-screen-layout';
import { ApiKeyList } from '../../../features/api-keys/components/api-key-list';
import { CreateApiKeyModal } from '../../../features/api-keys/components/create-api-key.modal';
import { uiStore } from '../../../core/stores/ui-store';
import { ApiKey } from '../../../features/api-keys/store/api-key.slice';
import { openModal } from '../../../core/modal/open-modal';

export const DevelopersSettingsRoute: React.FC = () => {
  const [lastCreatedKey, setLastCreatedKey] = useState<ApiKey | null>(null);

  useEffect(() => {
    uiStore.showBack = true;
    uiStore.currentLocation = 'space.settings.developers';
    return () => {
      uiStore.currentLocation = '';
    };
  }, []);

  const openCreateModal = () => openModal(CreateApiKeyModal, {
    onCreated: (apiKey) => setLastCreatedKey(apiKey),
  });

  return (
    <SettingScreenLayout
      title="Developers"
      actions={<ElevatedButton text="Create API key" icon={<PlusIcon />} onClick={openCreateModal} />}
    >
      <ApiKeyList newKey={lastCreatedKey} />
    </SettingScreenLayout>
  );
};
